import politicaDePrivacidade from '@/features/legal/conteudo/politica-de-privacidade.md?raw';
import { LegalLayout } from '@/features/legal/components/LegalLayout';

export function PoliticaDePrivacidadePage() {
  return (
    <LegalLayout
      titulo="Política de Privacidade e Proteção de Dados Pessoais"
      descricao="Princípios, práticas e procedimentos adotados no tratamento de dados pessoais coletados pela plataforma digital Nohra Clinic, incluindo o regime específico da Área de Discussão de Casos Clínicos."
      metadados={[
        { rotulo: 'Início da vigência', valor: '1º de setembro de 2026' },
        { rotulo: 'Versão do documento', valor: '2.0' },
        { rotulo: 'Última atualização', valor: '31 de agosto de 2026' },
        { rotulo: 'Substitui a versão', valor: '1.0, de maio de 2026' },
      ]}
      entidade="NOHRA INTELIGÊNCIA E GESTÃO INTEGRADA EM SAÚDE VETERINÁRIA LTDA · nome fantasia NOHRA CLINIC · CNPJ 66.801.517/0001-98 · Rua Alvorada, 1289, Conj. 708 a 710, Aparecida de Goiânia, Goiás · contato@nohraclinic.com.br · (11) 5539-3535 · www.nohraclinic.com.br"
      markdown={politicaDePrivacidade}
    />
  );
}
